import React from 'react';

const Teach = () => <div className="teach">Opetuksen etusivu</div>;

export default Teach;
